import ArrowChevron from './ArrowChevron';

export default ArrowChevron;
